import React from "react";
import PropTypes from "prop-types";
import sortBy from "lodash/sortBy"
import services from "../../../services/glue/appGlue";

class UsersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { shouldToggleEditMode: false };
  }

  handleRemoveUser(assignmentId) {
    return () => {
      if (assignmentId) {
        this.props.onRemoveUser(assignmentId);
      }
    };
  }

  handlePermissionChange(assignmentId) {
    return value => {
      this.props.onPermissionChange(assignmentId, value);
    };
  }

  toggleRoleDropdownOpened(value) {
    return () => {
      this.setState({ shouldToggleEditMode: value });
    };
  }

  getRows() {
    let users = sortBy(this.props.users, "name");
    let toggleRoleDropdownOpenedFn = this.toggleRoleDropdownOpened.bind(this);
    return users.map(user => {
      return (
        <UsersListRow
          key={user.assignmentId ? "assignment" + user.assignmentId : "user" + user.userId}
          user={user}
          shouldToggleEditMode={!this.state.shouldToggleEditMode}
          onOpenDropdown={toggleRoleDropdownOpenedFn(true)}
          onCloseDropdown={toggleRoleDropdownOpenedFn(false)}
          onPermissionChange={this.props.onPermissionChange}
          onRemoveUser={this.props.onRemoveUser}
        />
      );
    });
  }

  render() {
    return (
      <div className="acl-tbl-wrapper open-tbl">
        <div className="current-users__header">
          <i className="acl-i-user-group" />{" "}
          {services.Localize.getLocalizedString("_Storyboards.SharePanel.MembersTable.Header_")}
        </div>
        <table className="share-storyboard-table" id="shareStoryboardTable">
          <thead className="share-storyboard-table__header" id="shareStoryboardHeader">
            <tr>
              <th>
                {services.Localize.getLocalizedString("_Storyboards.SharePanel.MembersTable.ColumnHeaders.Name_")}
              </th>
              <th>
                {services.Localize.getLocalizedString("_Storyboards.SharePanel.MembersTable.ColumnHeaders.Email_")}
              </th>
              <th width="150px">
                {services.Localize.getLocalizedString(
                  "_Storyboards.SharePanel.MembersTable.ColumnHeaders.Permissions_"
                )}
              </th>
              <th width="20px" />
            </tr>
          </thead>
          <tbody className="share-storyboard-table__body" id="shareStoryboardUserList">
            {this.getRows()}
          </tbody>
        </table>
      </div>
    );
  }
}

UsersList.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      assignmentId: PropTypes.number,
      userId: PropTypes.number,
      groupId: PropTypes.number,
      name: PropTypes.string.isRequired,
      email: PropTypes.string,
      role: PropTypes.string,
    })
  ).isRequired,
  onPermissionChange: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func,
};

window.UsersList = UsersList;
